import * as React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import CafeProfileCard from './components/CafeProfileCard';
import Loading from '../../components/ui/Loading';
import { useGetCafeProfileQuery } from '../../store/api/cafeApi';
import NotesCardGroup from '../../components/shared/RelatedNoteSection/NotesCardGroup';
import { DEFAULT_CAFE } from '../../utils/constant';
import { extractIdFromURL } from '../../utils/common';

const CafeProfilePage = () => {
  const location = useLocation();
  const id = extractIdFromURL(location.pathname)
    ? extractIdFromURL(location.pathname)
    : DEFAULT_CAFE;
  const { data: cafe, isLoading } = useGetCafeProfileQuery(id);
  if (isLoading) return <Loading />;
  if (!cafe) return <Navigate to="/notfound" replace />;

  return (
    <>
      <CafeProfileCard cafe={cafe.data} />
      <NotesCardGroup
        displayName={cafe.data.cafeName}
        noteCardData={cafe.data.relatedNotes}
        typeofTitle="More notes on"
      />
    </>
  );
};

export default CafeProfilePage;
